import { render, staticRenderFns } from "./extract-detail.vue?vue&type=template&id=0248c328&scoped=true&"
import script from "./extract-detail.vue?vue&type=script&lang=ts&"
export * from "./extract-detail.vue?vue&type=script&lang=ts&"
import style0 from "./extract-detail.vue?vue&type=style&index=0&id=0248c328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248c328",
  null
  
)

export default component.exports